import i18n from '@/i18n';
import { formatCurrency, formatDate, formatDateTime } from '@/utils/formatters';

export function formatStripeDate(
  value?: string | number | null,
  opts?: { withTime?: boolean }
): string {
  if (value === undefined || value === null) return i18n.t('billing:formatters.dateNotAvailable');
  const date = typeof value === 'number' ? new Date(value * 1000) : new Date(value);
  if (Number.isNaN(date.getTime())) return i18n.t('billing:formatters.dateNotAvailable');
  return opts?.withTime ? formatDateTime(date) : formatDate(date);
}

export function formatStripeAmount(
  amountInCents?: number | null,
  currency?: string | null
): string {
  if (amountInCents === undefined || amountInCents === null) return i18n.t('billing:formatters.amountNotAvailable');
  return formatCurrency(amountInCents, (currency || 'eur') ?? 'eur');
}

